module.exports = __webpack_public_path__ + "img/left-icon.dc10745f.svg";